import queryString from "query-string"

type MOLocationType = {
  init(): MOLocationType
  hideURL(url: string): void
  unhideURL(): void
  getLocation(): Location
  getQueryParams(): queryString.ParsedQuery<string | boolean>
  getQueryParamsV2(): queryString.ParsedQuery<string | boolean>
  reload(): void
  getURLParamValue(name: string): string | boolean | null
}

const defaultObject = (function () {
  const parseURLQuery = () => {
    const urlParamsString = window.location.search + window.location.hash
    const query = queryString.parse(urlParamsString, {
      parseBooleans: true,
      parseNumbers: false
    })
    query.roomHash = window.location.pathname.replace("/", "").trim()
    return query
  }

  let _location = { ...window.location }
  let _queryParams = parseURLQuery()

  return {
    // public interfaces
    init() {
      _location = { ...window.location }
      _queryParams = parseURLQuery()
      return this
    },
    hideURL(url) {
      window.history.replaceState("", "", url)
    },
    unhideURL() {
      const oldURL = `${_location.pathname}${_location.search}`
      window.history.replaceState("", "", oldURL)
    },
    getLocation() {
      return _location
    },
    getQueryParams() {
      return _queryParams
    },
    getQueryParamsV2() {
      return parseURLQuery()
    },
    getURLParamValue(name) {
      return _queryParams[name]
    },
    reload() {
      window.location.reload()
    }
  }
})()
// defaultObject is use if window.MeetOnline.Location is undefined

const MOLocation: MOLocationType = window.MeetOnline.Location ?? defaultObject

export default MOLocation
